import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

function storeInLocalStorage(key, value) {
  if(localStorage.storeData !== undefined) {
    const storeData = JSON.parse(localStorage.storeData);
    storeData[key] = value;
    localStorage.setItem('storeData', JSON.stringify(storeData));
  } else {
    let storeData = {};
    storeData[key] = value;
    localStorage.setItem('storeData', JSON.stringify(storeData));
  }
};

export default new Vuex.Store({
  state: {
    api: process.env.VUE_APP_API,
    panel: process.env.VUE_APP_URL_PANEL,
    serviceType: 1, //service_types id
    mobileNav: 0,
    route: '',
    monthActive: -1,
    packetActive: -1,
    prices: {
      mini: [100, 90, 80],
      standard: [120, 110, 100],
      komfort: [150, 140, 130],
    },
    login: 0,
    validateStep: true,
    popupCode: 0,
    agreement: 0,
    orderNavDisable: false,
    isActivationCodeVerified: false,
    loggedIn: 0,
    alert:{
      visibility: 0,
      type: 0,
      msg: ''
    },
  },
  mutations: {
    initialiseStore(state) {
      if(localStorage.getItem('storeData')) {
        const storeData = JSON.parse(localStorage.storeData);
        Object.keys(storeData).forEach(key => {
          state[key] = storeData[key];
        });
      }
      // storeInLocalStorage('loggedIn', state.loggedIn);
    },
    toggleMobileNav(state){
      if(state.mobileNav){
        state.mobileNav = 0;
      }else{
        state.mobileNav = 1;
      }
    },
    changeRoute(state, payload){
      state.route = payload;
    },
    changeMonth(state, payload){
      state.monthActive = payload;
    },
    changePacket(state, payload){
      state.packetActive = payload;
    },
    changeLogin(state, payload){
      state.login = payload;
    },
    changeValidateStep(state, payload) {
      state.validateStep = payload;
    },
    togglePopupCode(state, payload) {
      state.popupCode = payload;
      storeInLocalStorage('popupCode', payload);
    },
    changePacketPrices(state, payload){
      state.prices = payload;
    },
    changeOrderNavDisable(state, payload) {
      state.orderNavDisable = payload;
    },
    toggleAgreement(state, payload) {
      state.agreement = payload;
    },
    changeActivationCodeVerification(state, payload) {
      state.isActivationCodeVerified = payload;
      storeInLocalStorage('isActivationCodeVerified', payload);
    },
    changeLoggedIn(state, payload) {
      state.loggedIn = payload;
      if(state.loggedIn == 0) {
        localStorage.removeItem('step2State');
        localStorage.removeItem('formData');
        localStorage.removeItem('formStep');
      }
      storeInLocalStorage('loggedIn', state.loggedIn);
    },
    toggleAlert(state, payload){
      state.alert.visibility = payload.visibility;
      state.alert.type = payload.type;
      state.alert.msg = payload.msg;
    },
  },
  actions: {
  },
  modules: {
  }
})
